/* eslint-disable */
<template>
  <q-page padding style="position: relative">
    <br>
    <div class="absolute-center text-center">    
      <img src="../assets/under_maintenance.jpg" />
      <h4>There is an upgrade in progress</h4>
      <h6>Our Factory Store is currently closed for an upgrade, please come back later to check out our newly added items</h6>
    </div>
</q-page>
</template>

<script>
/* eslint-disable */

export default {
  name: 'Maintenance',
  data (){
      return {
    }
  }
}
</script>
